import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import api from '../services/api'

export default function TrocarSenhaObrigatoria() {
  const { refreshUsuario, logout } = useAuth()
  const [senhaAtual, setSenhaAtual] = useState('')
  const [novaSenha, setNovaSenha] = useState('')
  const [confirmar, setConfirmar] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErro('')
    if (novaSenha.length < 8) return setErro('A nova senha deve ter pelo menos 8 caracteres')
    if (novaSenha !== confirmar) return setErro('As senhas não conferem')
    setLoading(true)
    try {
      await api.post('/auth/trocar-senha', { senhaAtual, novaSenha })
      await refreshUsuario()
    } catch (err) {
      setErro(err.response?.data?.erro || 'Não foi possível trocar a senha')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1 style={{ fontSize: 20, margin: '0 0 4px' }}>Troque sua senha</h1>
          <p>Por segurança, defina uma nova senha antes de continuar.</p>
        </div>
        {erro && <div className="alert alert-error">{erro}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Senha atual (temporária)</label>
            <input className="form-input" type="password" value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Nova senha</label>
            <input className="form-input" type="password" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required minLength={8} placeholder="mínimo 8 caracteres" />
          </div>
          <div className="form-group">
            <label className="form-label">Confirmar nova senha</label>
            <input className="form-input" type="password" value={confirmar} onChange={e => setConfirmar(e.target.value)} required minLength={8} />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', padding: '11px', marginTop: 6 }} disabled={loading}>
            {loading ? 'Salvando...' : 'Trocar senha'}
          </button>
          <button type="button" onClick={logout} style={{ width: '100%', marginTop: 10, background: 'none', border: 'none', color: '#888', fontSize: 12, cursor: 'pointer' }}>
            Sair
          </button>
        </form>
      </div>
    </div>
  )
}
